{
    "commonTitles": {
        "warning": "Warning",
        "confirmation": "Confirmation"
    },
    "cancelOrder": {
        "alertMsg": "Are you sure you want to cancel the order?"
    },
    "editOrderSuccess": {
        "title": "Thank you!",
        "messageLine1": "Your change request has been sent to the administrator.",
        "messageLine2": "We will notify you of the result by email.",
        "understoodBtn": "Understood"
    },
    "documents": {
        "upload": {
            "title": "Upload Document",
            "file": "File",
            "fileRequired": "Please select a file to upload",
            "fileSizeError": "File size exceeds 10MB limit",
            "selectedFile": "Selected file",
            "orderNumber": "Order Number",
            "selectOrder": "Select an order",
            "type": "Document Type",
            "typePlaceholder": "Enter document type",
            "documentNumber": "Document Number",
            "documentNumberPlaceholder": "Enter document number",
            "documentDate": "Document Date",
            "description": "Description",
            "descriptionPlaceholder": "Enter description",
            "comment": "Comment",
            "commentPlaceholder": "Enter comment"
        },
        "delete": {
            "alertMsg": "Are you sure you want to delete this document?",
            "fileName": "File name"
        }
    },
    "invoices": {
        "upload": {
            "title": "Upload Invoice",
            "file": "File",
            "fileRequired": "Please select a file to upload",
            "fileSizeError": "File size exceeds 10MB limit",
            "selectedFile": "Selected file",
            "orderNumber": "Order Number",
            "selectOrder": "Select an order",
            "recipientCompany": "Recipient Company",
            "selectCompany": "Select a company",
            "invoiceNumber": "Invoice Number",
            "invoiceNumberPlaceholder": "Enter invoice number",
            "type": "Invoice Type",
            "typePlaceholder": "Enter invoice type",
            "seller": "Seller",
            "sellerPlaceholder": "Enter seller name",
            "invoiceDate": "Invoice Date",
            "dueDate": "Due Date",
            "dueDateAfterInvoiceDate": "Due date must be after invoice date",
            "currency": "Currency",
            "amount": "Amount",
            "amountPaid": "Amount Paid",
            "amountPaidExceedsAmount": "Amount paid cannot exceed total amount",
            "status": "Status",
            "description": "Description",
            "descriptionPlaceholder": "Enter description",
            "comment": "Comment",
            "commentPlaceholder": "Enter comment"
        },
        "delete": {
            "alertMsg": "Are you sure you want to delete this invoice?",
            "invoiceNumber": "Invoice number"
        }
    },
    "individualTariffRequest": {
        "title": "Direct Tariff Request",
        "alertMsg": "Unfortunately, there are no tariffs available for your request. Leave your contact details and we will contact you to offer an individual solution",
        "deliveryTypeLbl": "Delivery type",
        "shippingTimeLbl": "Shipping time",
        "loadingDateLbl": "Loading date",
        "deliveryDateLbl": "Delivery date"
    },
    "addAddress": {
        "addTitle": "Add new contact",
        "editTitle": "Edit contact"
    },
    "deleteAddress": {
        "alertMsg": "Are you sure you want to permanently delete this contact from the address book?"
    },
    "company": {
        "addTitle": "Add Company",
        "editTitle": "Edit Company",
        "deleteAlertMsg": "Are you sure you want to permanently delete company \"{{companyName}}\"?"
    }
}